import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";
import { canViewByRoleCodes } from "src/core/shared/utils/canViewByRoleCodes";

import UsersPage from "../UsersPage";
import CustomersUsersPage from "./CustomersUsersPage";
import CreateUserPage from "./CreateUserPage";
import EditUserPage from "./EditUserPage";
import UserGroupsPage from "./UserGroupsPage";
import CreateEditUserGroupPage from "./CreateEditUserGroupPage";

const AdminUsers: IRoute[] = [
  {
    exact: true,
    path: "/admin/users/create",
    pageComponent: CreateUserPage,
    title: "Create %USER%",
    menuType: "EMPTY",
    privateRoute: true,
    context: "CREATE_EDIT_USER",
    permissions: [ "create-user" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/users/:userId",
    pageComponent: EditUserPage,
    title: "Edit %USER%",
    menuType: "EMPTY",
    privateRoute: true,
    context: "CREATE_EDIT_USER",
    permissions: [ "amend-user" ],
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    path: "/admin/users",
    pageComponent: UsersPage,
    icon: Icons.PEOPLE,
    title: "Admin Users",
    menuTitle: "Admin Users",
    menuType: "ADMIN_USERS",
    context: "LIST_USERS",
    privateRoute: true,
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/users/customers/all",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: CustomersUsersPage,
    icon: Icons.PEOPLEOUTLINE,
    title: "Customer Users",
    menuTitle: "Customer Users",
    menuType: "ADMIN_USERS",
    context: "LIST_USERS",
    privateRoute: true,
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/users/groups/all",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: UserGroupsPage,
    icon: Icons.GROUPS,
    title: "User Groups",
    menuTitle: "User Groups",
    menuType: "ADMIN_USERS",
    context: "LIST_USERS",
    privateRoute: true,
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/users/groups/create",
    pageComponent: CreateEditUserGroupPage,
    title: "Create user group",
    menuTitle: "Create user group",
    context: "CREATE_EDIT_USER_GROUP",
    menuType: "EMPTY",
    privateRoute: true,
    roles: [ "admin" ],
    permissions: [ "create-user" ]
  },
  {
    exact: true,
    path: "/admin/users/groups/edit/:userGroupId",
    pageComponent: CreateEditUserGroupPage,
    title: "Edit user group",
    context: "CREATE_EDIT_USER_GROUP",
    menuTitle: "Edit user group",
    menuType: "EMPTY",
    privateRoute: true,
    permissions: [ "amend-user" ],
    roles: [ "admin" ]
  }
];

export default AdminUsers;
